import { boolean, nativeEnum, number, object, string } from 'zod';

import {
  awardRestrictionsSchema,
  EmailRequiredConstraintSchema,
  FulfillmentChannelConstraintSchema,
  fulfillmentWindowSchema,
  minimumPurchaseConstraintsSchema,
  PaymentMethodConstraintSchema,
} from '@occc/feat-constraints/schemas';
import { Offer_Engagement_Type } from '@occc/graphql';
import {
  AwardExternalSchema,
  AwardPointsPerSchema,
  AwardPointsSchema,
  CustomDataSchema,
  OfferFulfillmentPrioritySchema,
  OfferNameAndDescriptionSchema,
  ScanDataConfigurationSchema,
  VoucheredOfferSchema,
} from '@occc/validation';

export const BaseOfferConfigurationSchema = OfferNameAndDescriptionSchema.merge(
  OfferFulfillmentPrioritySchema,
).extend({
  earningMechanism: object({
    id: string().optional(),
  }),
  fulfillmentWindow: fulfillmentWindowSchema,
  minimumPurchaseConstraints: minimumPurchaseConstraintsSchema,
  paymentMethodConstraint: PaymentMethodConstraintSchema,
  emailRequiredConstraint: EmailRequiredConstraintSchema,
  fulfillmentChannelConstraint: FulfillmentChannelConstraintSchema,
  awardRestrictions: awardRestrictionsSchema,
  customData: CustomDataSchema,
  engagementType: nativeEnum(Offer_Engagement_Type).optional().nullable(),
  awardPoints: AwardPointsSchema.partial().optional(),
  awardVouchers: object({
    voucheredOffer: VoucheredOfferSchema.partial().passthrough().optional(),
    isEnabled: boolean().optional(),
    voucherCount: number().optional(),
    voucherExpirationDays: number().optional(),
  })
    .partial()
    .optional(),
  awardPointsPer: AwardPointsPerSchema.partial().optional(),
  awardExternal: AwardExternalSchema.partial().optional(),
  scanDataConfiguration: ScanDataConfigurationSchema,
  campaign: object({
    uuid: string().min(1),
    name: string(),
  }).optional(),
});
